import { HandleVibrate } from "./HandleApiData";

export default function ButtonTab({
    index,
    title,
    onClick,
    icon,
    className,
    active,
}) {
    const onMouseUp = (e) => {
        HandleVibrate();
    }
    return (
        <button key={index}
            className={`setting-btn ${className ? className : ''} ${active ? 'active' : ''}`}
            onClick={onClick}
            onMouseUp={onMouseUp}
        >
            <div className="icon">
                {icon}
            </div>
            <span className="title">
                {title}
            </span>
        </button>
    );
}